import React from 'react';

const Services = () => {
  const services = [
    { title: 'SEO Optimization', desc: 'Boost your visibility and rank higher on search engines with our proven SEO strategies.', icon: '🔍' },
    { title: 'Pay-Per-Click Ads', desc: 'Maximize your ROI with targeted ad campaigns on Google, Facebook, and more.', icon: '🎯' },
    { title: 'Social Media', desc: 'Engage your audience and build brand loyalty across all social media platforms.', icon: '📱' },
    { title: 'Content Marketing', desc: 'Deliver valuable content that attracts, engages, and converts your target audience.', icon: '✍️' },
    { title: 'Web Development', desc: 'Custom, responsive websites designed to convert visitors into loyal customers.', icon: '💻' },
    { title: 'Graphic Designing', desc: 'Stunning visual assets that capture attention and communicate your brand message effectively.', icon: '🖌️' },
    { title: 'Video Editing', desc: 'Professional, high-impact video content that tells your story and drives engagement.', icon: '🎬' },
    { title: 'Brand Strategy', desc: 'Develop a cohesive brand identity that resonates with your target market.', icon: '💡' }
  ];

  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">
            Services Built to <br/>
            <span className="text-gradient-teal-gold">Scale Your Business</span>
          </h2>
          <p className="section-subtitle">We offer a full suite of digital marketing and creative services to help you achieve your goals.</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card" style={{ position: 'relative', overflow: 'hidden' }}>
              <div className="service-card-glow" style={{ position: 'absolute', top: '-50px', right: '-50px', width: '100px', height: '100px', background: 'radial-gradient(circle, rgba(43,213,196,0.2) 0%, rgba(0,0,0,0) 70%)', borderRadius: '50%' }}></div>
              <div className="service-icon-wrapper" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', boxShadow: '0 4px 15px rgba(0,0,0,0.2)' }}>
                <div className="service-icon" style={{ filter: 'drop-shadow(0 0 8px rgba(43, 213, 196, 0.4))' }}>{service.icon}</div>
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-desc">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
